import dynamic from "next/dynamic";
import {removeHtmlTags, slugify} from "@/lib/helpers/string";
import {Page} from "@/lib/interfaces/pages";
import Image from "@/components/blocks/Image";

const Event = dynamic(
    () => import('./blocks/Event')
)

const Text = dynamic(
    () => import('./blocks/Text')
)

const Faq = dynamic(
    () => import('./blocks/Faq')
)

const Offers = dynamic(
    () => import('./blocks/Offers')
)

const DynamicText = dynamic(
    () => import('./blocks/DynamicText')
)

const ContentCards = dynamic(
    () => import('./blocks/ContentCards')
)

const Carousel = dynamic(
    () => import('./blocks/Carousel')
)

const Futures = dynamic(
    () => import('./blocks/Futures')
)

const Spotlight = dynamic(
    () => import('./blocks/Spotlight')
)

const Parlay = dynamic(
    () => import('./blocks/Parlay')
)

const Table = dynamic(
    () => import('./blocks/Table')
)

const NextGames = dynamic(
    () => import('./blocks/event/NextGames')
)

const SportsTeamList = dynamic(
    () => import('./blocks/SportsTeamList')
)


type BlockResolverType = {
    parent?: Page|undefined
    blocks: any[]
}

export default function BlockResolver({parent, blocks}: BlockResolverType) {
    const blockElements = blocks.map((block) => {
        const element = () => {
            switch(block.type) {
                case "text":
                    return <Text block={block} />
                case "faq":
                    return <Faq block={block} />
                case "event-block":
                    return <Event block={block} />
                case "offers-area":
                    return <Offers block={block} />
                case "app-placeholder":
                    return <DynamicText block={block} />
                case "content":
                    return <ContentCards parent={parent} block={block} />
                case "carousel":
                    return <Carousel block={block} />
                case "futures-block":
                    return <Futures block={block} />
                case "spotlight":
                    return <Spotlight block={block} />
                case "parlay-block":
                    return <Parlay block={block} />
                case "table":
                    return <Table block={block} />
                case "next-events-block":
                    return <NextGames block={block} />
                case "teams":
                    return <SportsTeamList block={block} />
                case "image":
                    return <Image block={block} />
            }
        }
        let title = `block-${block.id}`;
        if (
          block.content &&
          block.content.sidebar_title &&
          (block.content.sidebar_title.hasOwnProperty('en') ||
            block.content.sidebar_title.hasOwnProperty)
        ) {
          if (block.content.sidebar_title.hasOwnProperty('en')) {
            title = removeHtmlTags(block.content.sidebar_title.en ?? '');
          } else {
            title = removeHtmlTags(block.content.sidebar_title ?? '');
          }
        }
        return (
            <div id={`${slugify(title)}`} key={`block-${block.id}`} className={`block-section block-section__${block.type}`}>{element()}</div>
        )
    })
    return (
        <div>{blockElements}</div>
    )
}
